// The top position classes needed to ensure that sticky submenus avoid the main navigation
export const STICKY_SUB_NAV_POSITION_CLASSES = 'top-[51px] md:top-[64px]';

// Sub nav top + zones nav height (50px / md:66px / xl:58px) - update if the zones nav height changes
export const STICKY_BELOW_ZONES_NAV_POSITION_CLASSES =
  'top-[101px] md:top-[130px] xl:top-[122px]';
